module.exports = __webpack_public_path__ + "img/李东坡.e08d8cc4.jpg";